import { render } from "./UploadView.vue?vue&type=template&id=fa96f408&ts=true"
import script from "./UploadView.vue?vue&type=script&lang=ts"
export * from "./UploadView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__